<template>

<v-container  fluid ma-0 pa-0 fill-height>
  <v-navigation-drawer
   v-model="drawer"
   app
   width="50%"

  >
  <v-container>
    <v-app-bar

      color="primary"
      dark
    >
<v-btn @click="deleteMap" v-if="data && data.file && data.file.length > 0"><v-icon>mdi-delete</v-icon>{{ $t('editor.delete_map')}}</v-btn>
  </v-app-bar>


    <SvgPanZoom
    v-if="data !== null && data.file && data.file.length > 0"
     id="panZoom"
 style="width: 100%; height: 100%;"
 :zoomEnabled="true"
 :key="k"
 :controlIconsEnabled="true"
 :fit="false"
 :center="true"
 >

   <svg  :key="k_svg" id="mySvg" :height="img_dim.h" :width="img_dim.w" >
     <image   v-if="data.file"   :xlink:href="base_url+place+'/'+data.file" id="img_canvas" :height="img_dim.h" :width="img_dim.w"/>

   </svg>
   </SvgPanZoom>
   <p v-else>
     {{ $t('editor.upload_map' )}}
   <input type="file" @change="onFileChange"></p>


</v-container>
</v-navigation-drawer>

<v-toolbar :extended="extended"  extension-height="35"  id="btn_toggle">
  <v-btn v-if="data" fab color="primary" target="_blank" :to="{name:'Home', params: {place: this.place}, query: {key: data.key}  }" icon>
          <v-icon>mdi-eye</v-icon>
        </v-btn>
  <v-btn fab color="primary" @click="dialog3 = !dialog3" icon>
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
  <v-btn fab color="primary" @click="dialog2 = !dialog2" icon>
          <v-icon>mdi-information-outline</v-icon>
        </v-btn>

  <v-btn fab color="primary" @click="drawer= !drawer" icon>
          <v-icon>mdi-map</v-icon>
        </v-btn>
        <v-btn fab icon  color="primary" @click="add_start">
          <v-icon>mdi-triangle-outline</v-icon>
        </v-btn>

                <v-btn  fab icon color="primary" @click="add_finish" >
                  <v-icon>mdi-circle-double</v-icon>
                </v-btn>

                <v-btn  fab icon  color="primary" @click="add_control"  >
                  <v-icon>mdi-circle-outline</v-icon>
                </v-btn>
                <v-btn  fab icon  color="primary" @click="importation()" >
                  <v-icon>mdi-import</v-icon>
                </v-btn>
                        <v-btn  :loading="saving" fab icon color="primary" @click="save" >
                          <v-icon>mdi-content-save</v-icon>
                        </v-btn>
                          <input  v-if="extended" class="ma-0" slot="extension"  type="file" @change="onFileChange2" />

                      <v-dialog v-model="dialog" persistent max-width="290">
                        <v-card>
                                <v-card-title class="headline">Choisissez le circuit à utiliser</v-card-title>
                                <v-card-text>
                                  <v-radio-group v-model="radioGroup">
   <v-radio
     v-for="n in Object.keys(courses)"
     :key="n"
     :label="n"
     :value="n"
   ></v-radio>
 </v-radio-group>
                              </v-card-text>
                                <v-card-actions>
                                  <v-spacer></v-spacer>
                                  <v-btn color="green darken-1" text @click="dialog = false">Annuler</v-btn>
                                  <v-btn v-if="radioGroup.length > 0" color="green darken-1" text @click="selectCourse">Valider</v-btn>
                                </v-card-actions>
                              </v-card>
                      </v-dialog>
</v-toolbar>


  <div id="map">
  </div>
  <v-dialog v-model="dialog2" persistent max-width="400">
    <v-card>
      <v-card-title><h3>Explications</h3><v-spacer/><v-btn icon @click="dialog2 = false;"><v-icon>mdi-close</v-icon></v-btn></v-card-title>
      <v-card-text>
        <p>Bienvenue sur l'éditeur de course. Celui-ci vous permet de générer/modifier un circuit de CO Virtuelle.</p>
        <p>Pour démarrer vous devez charger un fond de carte (la carte CO avec le tracé dessus au format image JPG/PNG si possible poids inférieur à 2Mo) avec l'icône <v-icon>mdi-map</v-icon> </p>
        <p>Ensuite vous devez créer le circuit sur la partie Google Maps : vous avez deux possibilités (A ou B) : </p>
        <p>A)Via OCAD, si votre carte/circuits sont géoréférencés, vous pouvez faire un export XML du circuit puis l'importer dans cet outil avec l'icône <v-icon>mdi-import</v-icon>. Si vous avez déjà créé un circuit dans l'outil il sera écrasé (supprimé).</p>
        <p>B) <v-icon>mdi-triangle-outline</v-icon><v-icon>mdi-circle-double</v-icon><v-icon>mdi-circle-outline</v-icon> vous permettent respectivement d'ajouter un départ, une arrivée et un poste au centre de la carte.</p>
        <p>Vous pouvez déplacer les marqueurs (sur Google Maps) pour les positionner précisément là où vous voulez (ou s'ils sont mal pré positionnés), vous pouvez cliquer dessus pour en supprimer.</p>
        <p><v-icon>mdi-content-save</v-icon> vous permet d'enregistrer votre travail (c'est fait automatiquement après chaque modification)</p>
        <p><v-icon>mdi-pencil</v-icon> vous pouvez modifier les informations générales (titre, activé/désactivé, pays, ...)</p>
        <p><v-icon>mdi-information-outline</v-icon> vous permet de rouvrir cette fenêtre afin de relire ces informations</p>
        <p><v-icon>mdi-eye</v-icon> vous permet d'ouvrir votre carte (même si celle-ci est inactive et protegée) pour visualiser et tester. La 1ere fois cela ouvre une nouvelle fenêtre, ensuite vous n'avez plus qu'à actualiser cette nouvelle fenêtre.</p>

      </v-card-text>
    </v-card>
  </v-dialog>
  <v-dialog v-model="dialog3" persistent max-width="400">
    <v-card v-if="data !== null">
      <v-card-title><h3>Modification</h3><v-spacer/><v-btn icon @click="dialog3 = false;"><v-icon>mdi-close</v-icon></v-btn></v-card-title>
      <v-card-text>
      <v-form @submit.prevent="submit">
          <v-text-field v-model="data.title" :label="$t('title')" :placeholder="$t('title')" outlined />
          <v-text-field v-model="data.thanks" :label="$t('thanks')" :placeholder="$t('thanks')" outlined />
          <v-text-field v-model="data.key" :label="$t('key')" :placeholder="$t('key')" outlined />
          <v-text-field v-model="data.country" :label="$t('country')" :placeholder="$t('country')" outlined />
          <v-subheader>Actif/inactif</v-subheader>
          <p>Si activé il apparaîtra sur la carte principale du jeu</p>
          <v-switch
     v-model="data.enabled"
     :label="data.enabled? 'activé':'désactivé'"
   ></v-switch>
        <v-text-field type="number" v-model="data.heading" :label="$t('heading')" :placeholder="$t('heading')" outlined />
        <v-btn  type="submit" block color="primary" :loading="loading">Modifier</v-btn>
      </v-form>

      </v-card-text>
    </v-card>
  </v-dialog>
</v-container>
</template>
<script>
import {Loader } from 'google-maps';
import firebase from '@firebase/app';
import IconComponent from './IconComponent';
import SvgPanZoom from 'vue-svg-pan-zoom';

import StartIcon from './StartIcon';
import   '@firebase/firestore';
var AWS = require('aws-sdk/global');
// import individual service
var S3 = require('aws-sdk/clients/s3');
import Vue from 'vue'

  export default {
    props: ['place'],
    components: {SvgPanZoom},
    data: () => ({
      bucketUrl: 'http://ogame-files.s3-website.eu-west-3.amazonaws.com',
      data: null,
      controls: [],
      dialog3: false,
      loading: false,
      dialog2: true,
      base_url: 'https://dy3fkqim66w1b.cloudfront.net/',
      drawer: false,
      courses: [],
      extended: false,
      polyline: null,
      img_dim: {w: null, h: null},
      controlsMarker: [],
      course: {start: {}, finish: {}, controls: []},
      map: null,
      dialog: false,
      saving: false,
      btn_toggle: null,
      radioGroup: '',
      k: 0,
      k_svg: 'svg_0',
      google: null,
      StartIcon: Vue.extend(StartIcon),
      IconComponent: Vue.extend(IconComponent),
      s3: null
    }),
    watch: {

  },


    mounted() {
      AWS.config.update({
        region: 'eu-west-3',
        //AKIAYFXWCLI2OD5G7QNP
        //0rBwhYebokm+HUPDyZmAXDoC1ak6gLMsLXt/932T
        credentials: new AWS.Credentials({
          accessKeyId: 'AKIAYFXWCLI2OD5G7QNP',
          secretAccessKey: '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'
        })
      });

      this.s3 = new AWS.S3({
        apiVersion: "2006-03-01",
        params: { Bucket: 'ogame-files' }
      });

      const self = this;
      const loader = new Loader('AIzaSyDreGT2CpjlKcExFi_7FXkqzP6E0pHU34w', {libraries: ["places"]});
      loader.load().then(function (google) {
        self.google = google;
        self.map = new google.maps.Map(document.getElementById('map'), {
          center: {lat: 47.491224, lng: 4.11484},
          zoom: 8,
          addressControl: true,
          disableDefaultUI: false
        });


      });
      let db  = firebase.firestore();
      db.collection('maps').doc(this.place).get().then((d) => {
        if (d.exists) {
          let map_data = d.data();
          if (map_data.enabled || (map_data.enabled == false && this.$route.query.key && this.$route.query.key == map_data.key)) {
            this.init(d.data());
          } else {
            alert(this.$t('place_disabled'));
          }

        } else {
          alert(this.$t('place_not_found') +' - 1');
        }
        self.mapAndDataLoaded();

      });
    },
    methods: {
      selectCourse() {
        let o = 1;
        this.course =  {start: {}, finish: {}, controls: []};
        this.controlsMarker = [];
        this.$forceUpdate();
        this.courses[this.radioGroup].forEach((c) => {
          const reg_start = RegExp('S', 'g');
          const reg_finish = RegExp('^F', 'g');

          let temp_c = this.controls.find((o) => o.id == c);
          if (temp_c) {
            if (reg_start.test(temp_c.id)) {
              this.course.start = {location: temp_c.loc};
            } else if (reg_finish.test(temp_c.id)) {
              this.course.finish= {location: temp_c.loc};
            } else {
              this.course.controls.push({order: o , location: temp_c.loc});
              o++;
            }
          }

        });
        this.mapAndDataLoaded();
        this.map.setCenter(this.course.start.location);
        this.save();
        this.dialog = false;
      },
      submit() {
        this.loading = true;
        this.data.heading = Number.parseInt(this.data.heading);
        const self = this;
        let db  = firebase.firestore();
        db.collection('maps').doc(this.place).set(this.data, { merge: true }).then(() => {
          self.loading = false;
          self.dialog3 = false;
        }).catch(() => {
          self.loading = false;
          alert('Error');
        })
      },
      add_start() {
        if (Object.keys(this.course.start).length == 0) {
            this.course.start.location = this.map.getCenter().toJSON();
            this.addMarker('start');
        } else {
          alert(this.$t('editor.control_already'))
        }
      },
      add_finish() {
        if (Object.keys(this.course.finish).length == 0) {
          this.course.finish.location = this.map.getCenter().toJSON();
        this.addMarker('finish');

      } else {
        alert(this.$t('editor.control_already'))
      }
    },
    add_control() {
        this.addMarker('control');
    },
      importation() {
        this.extended = !this.extended;
      },
      save() {
        if(this.data && this.$route.query.key && this.$route.query.key == this.data.key) {
          this.saving =  true;
          let db  = firebase.firestore();
          db.collection('maps').doc(this.place).update({course: this.course}).then(() => {
            this.saving =  false;
          }).catch(() => {
            this.saving =  false;
            alert('Issue');
          })
        } else {
          alert('Error');
        }

      },
      deleteMap() {
        if (window.confirm(this.$t('editor.confirm_delete_map'))){

          let params = {  Bucket: 'ogame-files', Key: this.place+'/'+this.data.file };

          let del = this.s3.deleteObject(params);
          var promise = del.promise();
promise.then(() => {
  let db  = firebase.firestore();
  db.collection('maps').doc(this.place).update({file: ''}).then(() => {
    this.data.file = '';
  });
}).catch(() => {
  //console.log(e);
  //console.log('error delete');
});






        }
      },
      drawPolyline() {
        let coords = [];
        if (this.course.start.location) {
          coords.push(this.course.start.location);
        }
        coords = coords.concat(this.course.controls.map(c => c.location));
        if (this.course.finish.location) {
          coords.push(this.course.finish.location);
        }
        if (this.polyline == null) {
          this.polyline = new this.google.maps.Polyline({
           path: coords,
           geodesic: true,
           strokeColor: '#800080',
           strokeOpacity: 1.0,
           strokeWeight: 2,
           map: this.map
         });
       } else {
         this.polyline.setPath(coords);
       }



      },
      parseIOF_XML(doc){

         doc.getElementsByTagName('Control').forEach((c) => {

           if (c.getElementsByTagName('Id').length > 0 && c.getElementsByTagName('Position').length > 0 ) {
              let pos = c.getElementsByTagName('Position');
              if (pos.length > 0) {
                this.controls.push({id: c.getElementsByTagName('Id')[0].innerHTML,   loc: {lat: Number.parseFloat(pos[0].getAttribute('lat')), lng:  Number.parseFloat(pos[0].getAttribute('lng'))}})

              }
           }

         });
          doc.getElementsByTagName('Course').forEach((c) => {
            this.courses[c.getElementsByTagName('Name')[0].innerHTML] = [];
              c.getElementsByTagName('CourseControl').forEach((cc) => {
                this.courses[c.getElementsByTagName('Name')[0].innerHTML].push(cc.getElementsByTagName('Control')[0].innerHTML)
              });

          });
          this.dialog = true;

      },
      parseGPX() {

      },
      parseXML(data) {
        let parser = new DOMParser();
        let xmlDoc = parser.parseFromString(data,"text/xml");
        try {
          let nodeName = xmlDoc.documentElement.nodeName;
          if (nodeName == 'CourseData') {
            this.parseIOF_XML(xmlDoc);
          } else {
            alert('Erreur');
          }

        }catch(error){
          alert(error);
        }



      },
      onFileChange2(e) {
        var files = e.target.files || e.dataTransfer.files;
        if (!files.length)
          return;
         let fr = new FileReader();
         const self = this;
         fr.onload = (e) => {
            self.parseXML(e.target.result);
           //console.log(vm.image);
         };
         fr.readAsText(files[0]);
      },
      onFileChange(e) {
     var files = e.target.files || e.dataTransfer.files;
     if (!files.length)
       return;
     this.createImage(files[0]);
   },
   refreshOrder() {
     this.course.controls.forEach((c,i) => {
       c.order = i+1;
     });
     this.controlsMarker.forEach((m, i) => {
       m.m.setLabel(Number(i + 1).toString());
     })
   },
   addMarkerLoopInit(location, type, i){
     let label = '';
     if (i) {
       label = i.toString();
     } else {
       label = type;
     }
     let m = new self.google.maps.Marker({
       position: location,
       map: this.map,
       label: label,
       draggable: true,
       title: type
     });
     if (type == 'control') {
       this.controlsMarker.push({o: i, m: m});
     }
     m.addListener('click', () => {

       if (window.confirm('Do you want to remove this marker ?')) {
         if (type == "control") {
           let index = this.course.controls.findIndex(f => f.order == i);
           let index2 = this.controlsMarker.findIndex(f => f.o == i);
           this.course.controls.splice(index, 1);
           this.controlsMarker.splice(index2, 1);
           this.refreshOrder();
         } else {
           this.course[type] = {};
         }


         m.setMap(null);
         this.drawPolyline();
          this.save();
       }
     });

    m.addListener('dragend', (e) => {

      if (type == 'control') {
        let o = this.course.controls.find(f => f.order == i);
        o.location = e.latLng.toJSON();
      } else {
         this.course[type].location = e.latLng.toJSON();
      }
      this.drawPolyline();
      this.save();
    });
   },
   addMarker(type) {
      let i = null;
    if (type == 'control') {
      i = this.course.controls.length + 1;
      this.course.controls.push({order: i, location: this.map.getCenter().toJSON() })
    } else {
      i = type;
    }

    let m = new self.google.maps.Marker({
     position: this.map.getCenter().toJSON(),
     map: this.map,
     label: i.toString(),
     draggable: true,
     title: type
   });
   if (type == 'control'){
     this.controlsMarker.push({o: i, m: m});
   }
   this.drawPolyline();

     m.addListener('click', () => {

       if (window.confirm('Do you want to remove this marker ?')) {
         if (type == "control") {
           let index = this.course.controls.findIndex(f => f.order == i);
           let index2 = this.controlsMarker.findIndex(f => f.o == i);
           this.course.controls.splice(index, 1);
           this.controlsMarker.splice(index2, 1);
           this.refreshOrder();
         } else {
           this.course[type] = {};
         }


         m.setMap(null);
         this.drawPolyline();
           this.save();
       }
     });

    m.addListener('dragend', (e) => {

      if (type == 'control') {
        let o = this.course.controls.find(f => f.order == i);
        o.location = e.latLng.toJSON();
      } else {
         this.course[type].location = e.latLng.toJSON();
      }
      this.drawPolyline();
      this.save();
    });
     return m;
   },
   createImage(file) {
     let filename = Math.random().toString(36).substr(2, 5) + '.'+file.type.split('/')[1];
     // Use S3 ManagedUpload class as it supports multipart uploads
     var upload = new S3.ManagedUpload({
       params: {
         Bucket: 'ogame-files',
         Key: this.place+'/'+filename,
         Body: file,
         ACL: "public-read"
       }
     });

     var promise = upload.promise();
     const self = this;
     promise.then(
       function() {
         let db  = firebase.firestore();
         db.collection('maps').doc(self.place).set({file: filename}, { merge: true }).then(() => {
           self.data.file = filename;
           window.location.reload();
           //self.k = Math.floor(Math.random() * Math.floor(50));
           //self.k_svg = 'svg_'+ Math.floor(Math.random() * Math.floor(50));
         }).catch(() => {
           alert('Error during upload / erreur pendant l\'envoi ');
         })
         // On update la database

       },
       function(err) {
         return alert("There was an error uploading your photo: ", err.message);
       }
     );

     //var image = new Image();
     var reader = new FileReader();
     var vm = this;
     //AKIAYFXWCLI2OD5G7QNP
     //0rBwhYebokm+HUPDyZmAXDoC1ak6gLMsLXt/932T
     reader.onload = (e) => {
       vm.image = e.target.result;
       //console.log(vm.image);
     };
     reader.readAsDataURL(file);
   },
   mapAndDataLoaded() {
     if (this.course && this.map) {
       this.course.controls.forEach((c) => {
         this.addMarkerLoopInit(c.location, 'control', c.order);
       });


       if (this.course.start.location) {
         this.addMarkerLoopInit(this.course.start.location, 'start', null);
         this.map.setCenter(this.course.start.location);
         this.map.setZoom(16);
       }
       if (this.course.finish.location) {
         this.addMarkerLoopInit(this.course.finish.location, 'finish', null);

       }
       this.drawPolyline();
     }
   },
      init(data) {
        this.data = data;
        const self = this;
        if(this.data.course) {
          this.course = this.data.course;


        }
        if (this.data && this.data.file && this.data.file.length > 0) {
          let i = new Image();
          i.onload = function() {

              self.img_dim.w = this.width;
              self.img_dim.h = this.height;
            }
          i.src = this.base_url+this.place+'/'+data.file;
        }

      },
      c() {

      }
    }

  }

</script>
<style>
#search {
      background-color: #fff;
      font-family: Roboto;
      font-size: 15px;
      font-weight: 300;
      margin-left: 12px;
      padding: 0 11px 0 13px;
      text-overflow: ellipsis;
      width: 400px;
    }

    #search:focus {
      border-color: #4d90fe;
    }
.controls-custom {
  position: absolute;
  right: 0;
  bottom: 50%;
}
#btn_toggle {
  position: absolute;
  z-index: 100;
  top: 25px;
  left: 50%;
}
#btn-container {
  min-width: 25px;
  min-height: 200px;
}
#map {
  height: 100%;
  width: 100%;
}

</style>
